import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getContractors } from "common/services/contractors.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectContractorAfiliatedTo = ({
  validation,
  selectedId,
  index,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
  index: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation?.touched?.affiliations?.[index]?.contractor &&
        validation?.errors?.affiliations?.[index]?.contractor
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation?.touched?.affiliations?.[index]?.contractor &&
          validation?.errors?.affiliations?.[index]?.contractor
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getContractors({
          pagination: {
            page: 1,
            pageSize: 20,
          },
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.contractorName || ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup key={index}>
      <Label
        htmlFor={`affiliations.${index}.contractor`}
        className="form-label"
      >
        Affiliated To Contractor
      </Label>
      <Select
        name={`affiliations.${index}.contractor`}
        id={`affiliations.${index}.contractor`}
        value={
          validation.values.affiliations[index].contractor.value
            ? validation.values.affiliations[index].contractor
            : null
        }
        placeholder="Select contractor"
        onChange={(value: any) => {
          validation.setFieldValue(`affiliations.${index}.contractor`, value);
          validation.setFieldError(`affiliations.${index}.contractor`, "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getContractors({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  contractorName: {
                    $containsi: inputValue,
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.contractorName || ""}`,
                };
              })
            );
          });
        }}
        onBlur={() =>
          validation.setFieldTouched(`affiliations.${index}.contractor`, true)
        }
        className={
          validation.touched.affiliations?.[index]?.contractor &&
          validation.errors.affiliations?.[index]?.contractor
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
        isClearable={true}
      />
      <FormFeedback>
        {validation.errors.affiliations?.[index]?.contractor?.value}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectContractorAfiliatedTo;
